"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./ViewerMap.css");
const mithril_1 = __importDefault(require("mithril"));
require("mithril/stream");
const leaflet_1 = __importDefault(require("leaflet"));
require("leaflet/dist/leaflet.css");
require("leaflet.locatecontrol");
// fontawesome stuff is needed by L.Control.Locate; pretty big! :(
require("@fortawesome/fontawesome-free/css/fontawesome.min.css");
require("@fortawesome/fontawesome-free/css/solid.min.css");
require("leaflet.locatecontrol/dist/L.Control.Locate.css");
require("../Act");
const pathsLayer_1 = __importDefault(require("../pathsLayer"));
const ViewerMap = ({ attrs: { visibleActs$, selectedActId$, multiselectedActIds$, hoveredActIds$ } }) => {
    function oncreate({ dom }) {
        const map = leaflet_1.default.map(dom, { renderer: leaflet_1.default.canvas(), tap: true });
        leaflet_1.default.control.locate({ drawCircle: false }).addTo(map); // HACK: drawCircle is disabled because it blocks other mouse events
        // ******
        // LAYERS
        // ******
        const attribution = '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/about-carto/">CARTO</a>';
        const ext = leaflet_1.default.Browser.retina ? '@2x.png' : '.png';
        // zIndex values:
        //  -100 - base map nolabels
        //     0 - pathsLayer (from PIXI)
        //   600 - markers (ViewerMap-marker-start & ViewerMap-marker-end)
        //   625 - base map only_labels
        //   650 - tooltips
        leaflet_1.default.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}' + ext, {
            zIndex: -100, pane: 'mapPane', attribution,
        }).addTo(map);
        leaflet_1.default.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}' + ext, {
            zIndex: 625, pane: 'mapPane', attribution,
        }).addTo(map);
        (0, pathsLayer_1.default)({ visibleActs$, selectedActId$, hoveredActIds$ }).addTo(map);
        // *******
        // MARKERS
        // *******
        const startMarker = leaflet_1.default.marker([0, 0], {
            opacity: 0, interactive: false,
            icon: leaflet_1.default.divIcon({
                className: 'ViewerMap-marker-start',
                iconSize: [12, 12],
            }),
            zIndexOffset: 20000, // needs to be large to overcome latitude-based zIndex
        }).addTo(map);
        const endMarker = leaflet_1.default.marker([0, 0], {
            opacity: 0, interactive: false,
            icon: leaflet_1.default.divIcon({
                className: 'ViewerMap-marker-end',
                html: '<div class="ViewerMap-marker-end-child"/>',
                iconSize: [12, 12],
            }),
            zIndexOffset: 10000,
        }).addTo(map);
        selectedActId$.map((selectedActId) => {
            const selectedAct = visibleActs$().find((act) => act.data.id === selectedActId);
            if (selectedAct && selectedAct.data.start_latlng) {
                startMarker.setLatLng(selectedAct.data.start_latlng);
                startMarker.setOpacity(1);
            }
            else {
                startMarker.setOpacity(0);
            }
            if (selectedAct && selectedAct.data.end_latlng) {
                endMarker.setLatLng(selectedAct.data.end_latlng);
                endMarker.setOpacity(1);
            }
            else {
                endMarker.setOpacity(0);
            }
        });
        // ************
        // INTERACTIONS
        // ************
        const tooltip = leaflet_1.default.tooltip();
        let panOrZoomInProgress = false;
        map.on('movestart', () => { panOrZoomInProgress = true; });
        map.on('moveend', () => { panOrZoomInProgress = false; });
        map.on('zoomstart', () => { panOrZoomInProgress = true; });
        map.on('zoomend', () => { panOrZoomInProgress = false; });
        let mouseHasMoved = false; // if this stays false, we're on a touch-only platform
        function refreshHoveredActIds(ev) {
            const projectedPt = map.getPixelOrigin().add(ev.layerPoint);
            // Determine the hovered acts
            const hoveredActs = visibleActs$().filter((act) => act.containsProjectedPoint(projectedPt, 7, map.getZoom()));
            hoveredActIds$(hoveredActs.map((act) => act.data.id));
            return hoveredActs;
        }
        map.on('mousemove', (ev) => {
            if (panOrZoomInProgress) {
                return;
            }
            mouseHasMoved = true;
            const hoveredActs = refreshHoveredActIds(ev);
            // Manage the tooltip
            if (hoveredActs.length === 0) {
                map.closeTooltip(tooltip);
            }
            else {
                const listedActs = hoveredActs.slice(0, 2);
                const numUnlistedActs = hoveredActs.length - 2;
                const tooltipContent = listedActs
                    .map((act) => `${act.data.name} (${act.startDate.toLocaleDateString()})`)
                    .join("<br/>")
                    + (numUnlistedActs > 0 ? `<br/>… and ${numUnlistedActs} more` : '');
                tooltip.setContent(tooltipContent);
                tooltip.setLatLng(ev.latlng);
                map.openTooltip(tooltip);
            }
            // TODO: Set cursor
        });
        // Deselect selected activity when background is clicked
        map.on('click', (ev) => {
            var _a;
            if (!mouseHasMoved) {
                refreshHoveredActIds(ev);
            }
            const hoveredActIds = hoveredActIds$();
            if (hoveredActIds.length === 0) {
                if (selectedActId$()) {
                    selectedActId$(undefined);
                }
                else if (multiselectedActIds$().length > 0) {
                    multiselectedActIds$([]);
                }
            }
            else if (hoveredActIds.length === 1) {
                selectedActId$((_a = visibleActs$().find((act) => act.data.id === hoveredActIds[0])) === null || _a === void 0 ? void 0 : _a.data.id);
            }
            else {
                multiselectedActIds$(hoveredActIds);
            }
            mithril_1.default.redraw();
        });
        // Fly to an activity if it is selected
        selectedActId$.map((selectedActId) => {
            const selectedAct = visibleActs$().find((act) => act.data.id === selectedActId);
            if (selectedAct) {
                // fly to activity in map
                if (selectedAct.latLngs) {
                    map.fitBounds(selectedAct.latLngs);
                }
            }
        });
        // Update URL from map view
        map.on('moveend', () => {
            const center = map.getCenter();
            const hash = `#@${center.lat.toFixed(7)},${center.lng.toFixed(7)},${map.getZoom().toFixed(2)}z`;
            window.history.replaceState(null, '', hash);
        });
        // One-time: set map view from URL or appropriate bounds
        if (window.location.hash !== '') {
            const numPat = "-?[0-9.]+";
            const match = window.location.hash.match(`^#@(${numPat}),(${numPat}),(${numPat})z$`);
            if (match) {
                map.setView({ lat: +match[1], lng: +match[2] }, +match[3]);
            }
        }
        else {
            let bounds;
            visibleActs$().forEach((act) => {
                if (!act.latLngs) {
                    return;
                }
                if (bounds) {
                    bounds.extend(act.latLngs);
                }
                else {
                    bounds = leaflet_1.default.latLngBounds(act.latLngs);
                }
            });
            if (bounds) {
                map.fitBounds(bounds);
            }
            else {
                map.fitWorld();
            }
        }
    }
    return {
        view: () => {
            return (0, mithril_1.default)('.ViewerMap', { oncreate });
        },
    };
};
exports.default = ViewerMap;
